import request from '@/utils/request'

// 首页组件商品
export function getIndexGoods(data) {
	return request({
		url: 'goods/get_index',
		method: 'post',
		data
	})
}

// 首页组件部分商品（想要什么组件就传对应参数）
export function getSomeGoods(data) {
	return request({
		url: 'goods/get_index_some',
		method: 'post',
		data
	})
}

// 获取魔方组件商品
export function getRubikCube(data) {
	return request({
		url: 'goods/get_rubik_cube',
		method: 'post',
		data
	})
}

// 限时抢购列表
export function getSeckillList(data) {
	return request({
		url: 'goods/get_seckill',
		method: 'post',
		data
	})
}

// 商品列表
export function getGoodsList(data) {
	return request({
		url: 'goods/list',
		method: 'post',
		data
	})
}
// 商品详情
export function getGoodsInfo(data) {
	return request({
		url: 'v1/goods/get_info',
		method: 'post',
		data
	})
}
// 商品规格
export function goodsChildSpec(data) {
	return request({
		url: 'v1/goods/goods_child_spec',
		method: 'post',
		data
	})
}

// 获取购物车列表
export function getCartList(data) {
	return request({
		url: 'cart/list',
		method: 'post',
		data
	})
}

// 加入、编辑购物车
export function addEditCart(data) {
	return request({
		url: 'cart/save_cart',
		method: 'post',
		data
	})
}

// 删除购物车商品
export function deleteCart(data) {
	return request({
		url: 'cart/delete',
		method: 'post',
		data
	})
}

// 设置是否选中
export function cartChecked(data) {
	return request({
		url: 'cart/cart_checked',
		method: 'post',
		data
	})
}


// 我关注的商品（我的货架）
export function getShelvesList(data) {
	return request({
		url: 'goods_shelves/my_list',
		method: 'post',
		data
	})
}

// 货架导出
export function exportShelves(params) {
	return request({
		url: 'goods_shelves/export_csv',
		method: 'get',
		params
	})
}

// 选品中心列表
export function getSelectionList(data) {
	return request({
		url: 'goods_shelves/list',
		method: 'post',
		data
	})
}

// 选品导出(全部)
export function exportProduct(params) {
	return request({
		url: 'goods_shelves/export_product_csv',
		method: 'get',
		params
	})
}

// 选品导出(单规格)
export function exportProductSingle(params) {
	return request({
		url: 'goods_shelves/export_product_csv_single',
		method: 'get',
		params
	})
}

// 关注商品
export function followGoods(data) {
	return request({
		url: 'goods_shelves/follow_goods',
		method: 'post',
		data
	})
}

// 取消关注商品
export function cancelFollowGoods(data) {
	return request({
		url: 'goods_shelves/del',
		method: 'post',
		data
	})
}

// 商品分类列表
export function getCategoryList(data) {
	return request({
		url: 'goods_category/list',
		method: 'post',
		data
	})
}

// 商品分类列表(按级查询)
export function getTopCategory(data) {
	return request({
		url: 'goods_category/top_category',
		method: 'post',
		data
	})
}

// 品牌列表
export function getBrandList(data) {
	return request({
		url: 'goods_brand/list',
		method: 'post',
		data
	})
}

// 产地列表
export function getOriginList(data) {
	return request({
		url: 'goods_origin/list',
		method: 'post',
		data
	})
}

// 待领取优惠券列表
export function getStayCoupon(data) {
	return request({
		url: 'coupon/stay_receive',
		method: 'post',
		data
	})
}

// 领取优惠券
export function receiveCoupon(data) {
	return request({
		url: 'coupon/receive',
		method: 'post',
		data
	})
}

// 未使用 已使用 已过期 优惠券列表
export function getCouponList(data) {
	return request({
		url: 'coupon/list',
		method: 'post',
		data
	})
}

// 特划算列表
export function activityths_lis(data) {
	return request({
		url: 'activity/ths_list',
		method: 'post',
		data
	})
}

// 特划算详情
export function activityths_info(data) {
	return request({
		url: 'activity/ths_info',
		method: 'post',
		data
	})
}

// 导出下载列表
export function download_list(data) {
	return request({
		url: 'goods_shelves/download_list',
		method: 'post',
		data
	})
}

// 获取楼层
export function get_floor_ad(data) {
	return request({
		url: 'goods/get_floor_ad',
		method: 'post',
		data
	})
}

// 获取楼层商品
export function get_group_goods(data) {
	return request({
		url: 'goods/get_group_goods',
		method: 'post',
		data
	})
}

// 分组列表
export function goods_group_list(data) {
	return request({
		url: 'goods/goods_group_list',
		method: 'post',
		data
	})
}

// 商品分组列表
export function group_goods_list(data) {
	return request({
		url: 'goods/group_goods_list',
		method: 'post',
		data
	})
}

// 分组商品导出
export function export_download(data) {
	return request({
		url: 'goods/export_download',
		method: 'post',
		data
	})
}

// 首页楼层
export function get_floor(data) {
	return request({
		url: 'goods/get_floor',
		method: 'post',
		data
	})
}

// 获取营业执照
export function get_business_license(data) {
	return request({
		url: 'goods/get_business_license',
		method: 'post',
		data
	})
}

// 商品价格趋势
export function price_trend(data) {
	return request({
		url: 'goods/price_trend',
		method: 'post',
		data
	})
}

// 变价列表
export function goods_price_log_list(data) {
	return request({
		url: 'goods/goods_price_log_list',
		method: 'post',
		data
	})
}

// 变跟列表导出
export function export_goods_price_log_list(data) {
	return request({
		url: 'goods/export_goods_price_log_list',
		method: 'post',
		data
	})
}

// 新商品规格接口
export function goods_spec(data) {
	return request({
		url: 'v1/goods/goods_spec',
		method: 'post',
		data
	})
}

// 商品销量
export function goods_sale(data) {
	return request({
		url: 'goods_shelves/goods_sale',
		method: 'post',
		data
	})
}

// 商品销量导出
export function goods_sale_export(data) {
	return request({
		url: 'goods_shelves/goods_sale_export',
		method: 'post',
		data
	})
}

// 统计购物车类型数量
export function cart_quantity(data) {
	return request({
		url: 'cart/quantity',
		method: 'post',
		data
	})
}

// 统计优惠券数量
export function statistics_coupon(data) {
	return request({
		url: 'coupon/statistics_coupon',
		method: 'post',
		data
	})
}

// 素材下载
export function downloadImg(data) {
	return request({
		url: 'v1/goods/download_img',
		method: 'post',
		data
	})
}

// 新人专享优惠券列表
export function lucky_draw_list(data) {
	return request({
		url: 'marketing/lucky_draw_list',
		method: 'post',
		data
	})
}

// 新人专享优惠券领取
export function save_coupon_record(data) {
	return request({
		url: 'marketing/save_coupon_record',
		method: 'post',
		data
	})
}

// 产品库 列表
export function goods_warehouse_list(data) {
	return request({
		url: 'set_meal/goods_warehouse_list',
		method: 'post',
		data
	})
}

// 批量加入商品库
export function add_goods_warehouse(data) {
	return request({
		url: 'set_meal/add_goods_warehouse',
		method: 'post',
		data
	})
}

// 移除商品库
export function del_goods_warehouse(data) {
	return request({
		url: 'set_meal/del_goods_warehouse',
		method: 'post',
		data
	})
}

// 店铺商品
export function supplier_goods_list(data) {
	return request({
		url: 'goods/supplier_goods_list',
		method: 'post',
		data
	})
}

